import React, { useEffect, useMemo, useState, useRef } from 'react'
import { Leva } from 'leva'
import { Canvas } from '@react-three/fiber'
import { ResizeObserver } from '@juggle/resize-observer'

import Scene from './scene'
import TerminalLoader, { AgentIdText } from './TerminalLoader'
import SwagModal from './SwagModal'
import { useAgentId } from './utils/pid'
import './index.scss'

// 💡 声明全局变量，防止 TypeScript 报错
declare global {
  interface Window {
    umami?: {
      track: (eventName: string, eventData?: any) => void;
    };
  }
}

const Index = function () {
  const members = useMemo(
    () => [
      '@Halette', '@4everyang', '@AlexRowe', '@Anderseas', '@AzureCandy', '@Ba1r0g',
      '@BGDajiu', '@chiakeshi', '@CrystaTech', '@csballinger', '@csdlbx', '@Dacongmingya',
      '@Daisy2025', '@Daydayuppp', '@Dengdage', '@fffancy', '@hezc1928', '@IceNavigator',
      '@jejejejely', '@komecco', '@lostngone', '@lzsvictor', '@Masterfod', '@Michael0071',
      '@MikanZuki', '@Nrabbit', '@PJ10086', '@PurpleRedRiver', '@RichardL1', '@SailingY',
      '@Snowrainbow', '@Sonicrx', '@TabrisJ', '@Unclebeldin', '@yantensh',
    ],
    []
  )
  
  const [startIndex, setStartIndex] = useState(0)
  const [showVideo, setShowVideo] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [lang, setLang] = useState<'zh' | 'en' | 'jp'>('en')
  
  const [soundOn, setSoundOn] = useState(true);
  const [loaderFadeOut, setLoaderFadeOut] = useState(false);
  const spaceAudio = useRef<HTMLAudioElement | null>(null);
  const agent = useAgentId();

  // 💡 图片弹窗的开关与当前索引
  const [photoOpen, setPhotoOpen] = useState(false);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);

  // 💡 周边弹窗
  const [swagOpen, setSwagOpen] = useState(false);
  const [swagLang, setSwagLang] = useState<'zh' | 'en' | 'jp'>('zh');

  const videoRef = useRef<HTMLVideoElement | null>(null)
  const videoUrl = 'https://xyinkl.oss-cn-beijing.aliyuncs.com/Link2Inf-Final.mp4'
  const reportUrls = {
    en: 'https://vtx.space/archives/link2infrep',
    zh: 'https://vtx.space/archives/link2infrep',
    jp: 'https://vtx.space/archives/link2infjp',
  }

  // 💡 更新了完整的人工挑选的照片列表
  const actionPhotos = [
    { src: '/photos/image-44.png' },
    { src: '/photos/image-43.png' },
    { src: '/photos/image_2025-09-14_01-04-28.png' },
    { src: '/photos/FinalSet.jpg' },
    { src: '/photos/Screen-Shot-2025-09-15-07-26-48.98.png' },
    { src: '/photos/image-4.png' },
    { src: '/photos/image-5.png' },
    { src: '/photos/2025-09-14-scguqngg.png' },
    { src: '/photos/image-7.png' },
    { src: '/photos/2025-09-14-xjvssdkm.jpg' },
    { src: '/photos/image-8.png' },
    { src: '/photos/image-9.png' },
    { src: '/photos/2025-09-14-isajigao.png' },
    { src: '/photos/2025-09-14-nkjahsqb.png' },
    { src: '/photos/image-16.png' },
    { src: '/photos/image-18.png' },
    { src: '/photos/image-25.png' },
    { src: '/photos/2025-09-14-jbhnjrsb.png' },
    { src: '/photos/image-30.png' },
    { src: '/photos/image-31.png' },
    { src: '/photos/image-34.png' },
    { src: '/photos/image-35.png' },
    { src: '/photos/image-36.png' },
    { src: '/photos/image-37.png' },
    { src: '/photos/2025-09-14-mappbrgn.png' },
    { src: '/photos/2025-09-14-ufcritry.png' },
    { src: '/photos/image-42.png' },
    { src: '/photos/6881nmmge.jpg' },
    { src: '/photos/6881nmmge2.jpg' },
    { src: '/photos/6881nmmchat.jpg' },
    { src: '/photos/6881nmmholy.jpg' },
    { src: '/photos/6881nmmifs.png' },
    { src: '/photos/nmmbu.jpg' },
    { src: '/photos/sybimage_201.png' },
    { src: '/photos/2025-10-22-veuprydo.jpeg' },
    { src: '/photos/syb_E4_B8_8B_E8_BD_BD__4_.jpg' },
    { src: '/photos/syb_E4_B8_8B_E8_BD_BD__9_.jpg' },
    { src: '/photos/sybimage_202.png' },
    { src: '/photos/sybiris.jpg' },
    { src: '/photos/sybmc.jpg' },
    { src: '/photos/sybimage_203.png' },
    { src: '/photos/sybimage_204.png' },
    { src: '/photos/syb_E4_B8_8B_E8_BD_BD__7_.jpg' },
    { src: '/photos/sybsss6.jpg' },
    { src: '/photos/sybxies.jpg' },
    { src: '/photos/syb_E4_B8_8B_E8_BD_BD__8_.jpg' },
    { src: '/photos/2025-10-23-dwtlslym.jpg' },
    { src: '/photos/2025-10-23-jeunzocq.jpg' },
    { src: '/photos/2025-10-23-opxcyykv.jpg' },
    { src: '/photos/2025-10-23-xaptjbxh.png' },
    { src: '/photos/2025-10-23-ihbwwrhz.png' },
    { src: '/photos/2025-10-23-rjpagplw.jpg' },
    { src: '/photos/2025-10-24-ypvnykyb.png' },
    { src: '/photos/2025-10-24-kantxioq.png' },
    { src: '/photos/2025-10-28-vgvleusq.jpg' },
    { src: '/photos/2025-10-28-jvyxmkgc.jpg' },
    { src: '/photos/2025-10-28-dfuhyvme.jpg' },
    { src: '/photos/2025-10-31-dxlvskxk.png' },
    { src: '/photos/2025-10-31-totahfsj.jpg' },
    { src: '/photos/2025-10-31-uafvlkyq.png' },
    { src: '/photos/2025-10-31-ammnycfa.png' },
    { src: '/photos/2025-10-31-zdilvgzd.png' },
    { src: '/photos/2025-10-31-dolpdkby.png' },
    { src: '/photos/2025-10-31-hfmfcwvq.png' },
    { src: '/photos/2025-10-31-zjvqoost.png' },
    { src: '/photos/2025-10-31-hdzynywo.png' },
    { src: '/photos/2025-10-31-topvqjna.png' },
    { src: '/photos/2025-11-12-mcdoract.png' },
    { src: '/photos/2025-11-12-fdplxhio.png' },
    { src: '/photos/2025-11-12-hdskadjy.png' },
    { src: '/photos/2025-11-12-xpixpooe.png' },
  ]

  const handleNextPhoto = () => {
    setCurrentPhotoIndex((prev) => (prev + 1) % actionPhotos.length);
  };

  const handlePrevPhoto = () => {
    setCurrentPhotoIndex((prev) => (prev - 1 + actionPhotos.length) % actionPhotos.length);
  };

  const nextPhoto = (e: React.MouseEvent) => {
    e.stopPropagation();
    handleNextPhoto();
  };

  const prevPhoto = (e: React.MouseEvent) => {
    e.stopPropagation();
    handlePrevPhoto();
  };

  useEffect(() => {
    if (!photoOpen) return; 
    
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight') {
        handleNextPhoto();
      } else if (e.key === 'ArrowLeft') {
        handlePrevPhoto();
      } else if (e.key === 'Escape') {
        setPhotoOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [photoOpen, actionPhotos.length]);

const content = useMemo(
    () => ({
      en: {
        title: 'OP.Link2Infinity',
        desc:
          'On September 10, 2025, the Resistance agents from China, including @Xyinkl @SSSunlight @irisierend @Leexiaoyu @Kingmos @NanoApe @C7June @genthz, cooperating with multinational agents, successfully completed the "OP.Link2Infinity" operation, shooting the longest Ingress in-game Link so far from [Yumen, Gansu, China] to [Unalaska, Alaska, USA]. \nThe Link length reached 6881.279958km, just 42 mm short of the theoretical maximum Link distance.',
        label: 'Language',
        agentThanksL1: 'Thank you,',
        agentThanksL2: 'Agent',
        thanks: 'Special Thanks',
        linkText: 'Briefing',
        reportText: 'SitRep',
        photoText: 'Photos',
        swagText: 'Swag',
        bgm: 'BGM',
        on: 'ON',
        off: 'OFF',
        bgmCredit: 'BGM from "Prelude - Reunion" FF VII REMAKE OST by Nobuo Uematsu & Katsutaka Suzuki'
      },
      zh: {
        title: 'OP.Link2Infinity',
        desc:
          '2025年9月10日，来自中国的蓝军 @Xyinkl @SSSunlight @irisierend @Leexiaoyu @Kingmos @NanoApe @C7June @genthz，在多国友军的协力下，从 [中国甘肃玉门] 成功连接至 [美国阿拉斯加 Unalaska]，完成了 Ingress 游戏史上迄今为止最长的 Link——6881.279958km。\n这一距离，距离理论极限仅差 42 毫米。',
        label: '语言',
        agentThanksL1: '感谢你，',
        agentThanksL2: '特工',
        thanks: '特别鸣谢',
        linkText: '行动视频',
        reportText: '查看战报',
        photoText: '行动照片',
        swagText: '纪念周边',
        bgm: '背景音',
        on: '开',
        off: '关',
        bgmCredit: 'BGM from《プレリュード -再会-》FF VII REMAKE OST 植松伸夫 & 鈴木克崇'
      },
      jp: {
        title: 'OP.Link2Infinity',
        desc:
          '2025年9月10日、中国のレジスタンスエージェント（@Xyinkl、@SSSunlight、@irisierend、@Leexiaoyu、@Kingmos、@NanoApe、@C7June、@genthz）を中心に多国籍の味方と協力し、Ingress内でこれまでで最も長いリンクを成功裏に作成しました。\nリンクは中国甘粛玉門からアメリカ・アラスカのウナラスカまで伸び、その距離は6881.279958kmに達し、理論上の最長リンク距離にわずか42mm届かない記録となりました。',
        label: '言語',
        agentThanksL1: 'ありがとうございます、',
        agentThanksL2: 'エージェント',
        thanks: 'スペシャルサンクス',
        linkText: '作戦映像',
        reportText: 'シットレップ',
        photoText: '作戦写真',
        swagText: 'グッズ',
        bgm: 'BGM',
        on: 'オン',
        off: 'オフ',
        bgmCredit: 'BGM from《プレリュード -再会-》FF VII REMAKE OST 植松伸夫 & 鈴木克崇'
      },
    }),
    []
  )

  const trackEvent = (eventName: string) => {
    if (typeof window !== 'undefined' && window.umami) {
      window.umami.track(eventName);
    } else {
      console.warn('Umami not found, event not tracked:', eventName);
    }
  };

  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth <= 768)
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  useEffect(() => {
    spaceAudio.current = new Audio('/sound/ff7intro.mp3');
    spaceAudio.current.loop = true;
    spaceAudio.current.volume = 0.35;
  }, []);

  useEffect(() => {
    if (loaderFadeOut && spaceAudio.current) {
      if (soundOn) {
        spaceAudio.current.play().catch(e => console.warn('Space audio blocked:', e));
      } else {
        spaceAudio.current.pause();
      }
    }
  }, [loaderFadeOut, soundOn]);

  useEffect(() => {
    if (!showVideo || !isMobile) return;
    const video = videoRef.current
    if (!video) return;
    const requestFullscreen = video.requestFullscreen || (video as any).webkitEnterFullscreen
    if (requestFullscreen) {
      try { requestFullscreen.call(video) } catch {}
    }
  }, [showVideo, isMobile])

  useEffect(() => {
    const interval = setInterval(() => {
      setStartIndex((prev) => (prev + (isMobile ? 1 : 10)) % members.length)
    }, 3000)
    return () => clearInterval(interval)
  }, [members.length, isMobile])

  const visibleMembers = useMemo(() => {
    const pageSize = isMobile ? 1 : 10
    const result: string[] = []
    for (let i = 0; i < pageSize; i += 1) {
      result.push(members[(startIndex + i) % members.length])
    }
    return result
  }, [members, startIndex, isMobile])

  const renderDesc = (text: string) => {
    const lines = text.split('\n')
    const mentionRegex = /@\w+|\[[^\]]+\]|\d{4}\s*年\s*\d{1,2}\s*月\s*\d{1,2}\s*日|\d{4}年\d{1,2}月\d{1,2}日|\b\d{4}\.\d{6,}\s*km\b|\b\d{4}\.\d{4}km\b|\b\d+\s*mm\b|\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2},\s*\d{4}\b|\b\d{1,2}\s*(?:January|February|March|April|May|June|July|August|September|October|November|December)\s*\d{4}\b/gi
    
    return lines.map((line, lineIndex) => {
      const parts: Array<string | { strong: string; isKm: boolean }> = []
      let lastIndex = 0
      let match: RegExpExecArray | null
      while ((match = mentionRegex.exec(line)) !== null) {
        const start = match.index
        if (start > lastIndex) {
          parts.push(line.slice(lastIndex, start))
        }
        const isKm = match[0].toLowerCase().includes('km')
        parts.push({ strong: match[0], isKm })
        lastIndex = start + match[0].length
      }
      if (lastIndex < line.length) {
        parts.push(line.slice(lastIndex))
      }

      return (
        <span key={`line-${lineIndex}`}>
          {parts.map((part, partIndex) => {
            if (typeof part === 'string') return <span key={`t-${lineIndex}-${partIndex}`}>{part}</span>
            return (
              <strong 
                className={`mention-strong ${part.isKm ? 'link-large' : ''}`} 
                key={`m-${lineIndex}-${partIndex}`}
              >
                {part.strong}
              </strong>
            )
          })}
          {lineIndex < lines.length - 1 && <br />}
        </span>
      )
    })
  }

  return (
    <div className={`index-page ${loaderFadeOut ? 'show-labels' : 'hide-labels'}`}>
      <div className="ui-overlay">
        <div className="ui-title">{content[lang].title}</div>
        
        {loaderFadeOut && (
          /* 💡 开启自动折行支持 */
          <div className="ui-button-group" style={{ flexWrap: 'wrap' }}>
            {/* 将视频和战报按钮包裹在一起保证不被强行拆分 */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <button 
                className="ui-button geek-nav-link" 
                onClick={() => {
                  trackEvent('Play Video');
                  setShowVideo(true);
                }}
              >
                {content[lang].linkText}
              </button>
              <span className="ui-button-separator">/</span>
              <button
                className="ui-button geek-nav-link"
                type="button"
                onClick={() => {
                  trackEvent('Open SitRep');
                  window.open(reportUrls[lang], '_blank', 'noopener,noreferrer');
                }}
              >
                {content[lang].reportText}
              </button>
              
              {/* 桌面端：和前两个按钮同行显示 */}
              {!isMobile && (
                <>
                  <span className="ui-button-separator">/</span>
                  <button
                    className="ui-button geek-nav-link"
                    type="button"
                    onClick={() => {
                      trackEvent('Open Photos');
                      setPhotoOpen(true);
                      setCurrentPhotoIndex(0); 
                    }}
                  >
                    {content[lang].photoText}
                  </button>
                  <span className="ui-button-separator">/</span>
                  <button
                    className="ui-button geek-nav-link"
                    type="button"
                    onClick={() => {
                      trackEvent('Open Swag');
                      setSwagLang(lang);
                      setSwagOpen(true);
                    }}
                  >
                    {content[lang].swagText}
                  </button>
                </>
              )}
            </div>

            {/* 💡 移动端换行逻辑：设定 width: 100% 强行挤压到下一行 */}
            {isMobile && (
              <div style={{ width: '100%', marginTop: '0px' }}>
                <button
                  className="ui-button geek-nav-link"
                  type="button"
                  onClick={() => {
                    trackEvent('Open Photos');
                    setPhotoOpen(true);
                    setCurrentPhotoIndex(0); 
                  }}
                >
                  {content[lang].photoText}
                </button>
                <span className="ui-button-separator">/</span>
                <button
                  className="ui-button geek-nav-link"
                  type="button"
                  onClick={() => {
                    trackEvent('Open Swag');
                    setSwagLang(lang);
                    setSwagOpen(true);
                  }}
                >
                  {content[lang].swagText}
                </button>
              </div>
            )}
          </div>
        )}
        
        <div className="ui-desc">{renderDesc(content[lang].desc)}</div>

        {/* 💡 移动端：Agent 致谢行固定在行动说明之后 */}
        {isMobile && agent.raw && (
          <div className="ui-agent-thanks">
            <div>{content[lang].agentThanksL1}</div>
            <div>
              {content[lang].agentThanksL2}{' '}
              <strong><AgentIdText raw={agent.raw} resolved={agent.resolved} ready={agent.ready} /></strong>
            </div>
          </div>
        )}
        
        {!isMobile && (
          <div className="ui-list-container is-desktop">
            {agent.raw && (
              <div className={`ui-agent-thanks${lang === 'en' ? ' ui-agent-thanks-en' : ''}`}>
                <div>{content[lang].agentThanksL1}</div>
                <div>
                  {content[lang].agentThanksL2}{' '}
                  <strong><AgentIdText raw={agent.raw} resolved={agent.resolved} ready={agent.ready} /></strong>
                </div>
              </div>
            )}
            <div className="ui-list-label">{content[lang].thanks}</div>
            <ul className="ui-list"><li>{visibleMembers[0]}</li></ul>
          </div>
        )}

        {isMobile && (
          <div className="ui-list-container is-mobile">
            <div className="ui-list-label">{content[lang].thanks}</div>
            <ul className="ui-list">
              {visibleMembers.map((member) => (
                <li key={member}>{member}</li>
              ))}
            </ul>
            <div 
              style={{
                marginTop: '12px',
                fontSize: '10px',
                lineHeight: 1.4,
                opacity: 0.6,
                letterSpacing: '0.5px',
                color: '#e9f1ff',
                fontFamily: "'Manolo Mono', 'Helvetica Neue', monospace",
                wordBreak: 'break-word',
                pointerEvents: 'none'
              }}
            >
              {content[lang].bgmCredit}
            </div>
          </div>
        )}

        <div className="ui-footer">
          <span>{content[lang].bgm}:</span>
          <button 
            className={`ui-lang ${soundOn ? 'active' : ''}`} 
            onClick={() => {
              trackEvent('Toggle BGM');
              setSoundOn(!soundOn);
            }}
          >
            {soundOn ? content[lang].on : content[lang].off}
          </button>
          
          <span style={{ margin: '0 8px', color: 'rgba(150, 190, 255, 0.4)' }}>//</span>

          <span>{content[lang].label}:</span>
          <button 
            className={`ui-lang ${lang === 'zh' ? 'active' : ''}`} 
            onClick={() => {
              trackEvent('Switch Lang: ZH');
              setLang('zh');
            }}
          >
            中
          </button>
          <span>|</span>
          <button 
            className={`ui-lang ${lang === 'en' ? 'active' : ''}`} 
            onClick={() => {
              trackEvent('Switch Lang: EN');
              setLang('en');
            }}
          >
            EN
          </button>
          <span>|</span>
          <button 
            className={`ui-lang ${lang === 'jp' ? 'active' : ''}`} 
            onClick={() => {
              trackEvent('Switch Lang: JP');
              setLang('jp');
            }}
          >
            JP
          </button>
        </div>
      </div>

      {!isMobile && (
        <div 
          className="ui-bgm-credit is-desktop" 
          style={{
            position: 'fixed',
            bottom: '24px', 
            left: 'calc(24px + 5vw)',
            display: 'flex',
            alignItems: 'center',
            height: '34px', 
            fontSize: '12px',
            opacity: 0.6,
            letterSpacing: '0.5px',
            pointerEvents: 'none',
            zIndex: 10,
            color: '#e9f1ff',
            fontFamily: "'Manolo Mono', 'Helvetica Neue', monospace"
          }}
        >
          {content[lang].bgmCredit}
        </div>
      )}
      
      <TerminalLoader onComplete={() => setLoaderFadeOut(true)} lang={lang} setLang={setLang} />
      
      <Canvas
        className={isMobile ? 'canvas-mobile' : undefined}
        resize={{ polyfill: ResizeObserver }}
        style={
          isMobile
            ? { width: '100vw', left: 0 }
            : { width: '150vw', position: 'absolute', left: '-10vw', top: 0 }
        }
      >
        <Scene></Scene>
      </Canvas>
      <Leva hidden />
      
      {/* 行动视频弹窗 */}
      {showVideo && (
        <div className="ui-modal">
          <div className="ui-modal-backdrop" onClick={() => setShowVideo(false)} />
          <div className="ui-modal-content">
            <video ref={videoRef} src={videoUrl} controls autoPlay playsInline={false} />
          </div>
        </div>
      )}

      {/* 💡 行动照片弹窗 */}
      {photoOpen && (
        <div className="ui-modal">
          <div className="ui-modal-backdrop" onClick={() => setPhotoOpen(false)} />
          <div className="ui-modal-content" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#000' }}>
            
            {/* 左翻页按钮 */}
            {actionPhotos.length > 1 && (
              <button 
                onClick={prevPhoto}
                style={{
                  position: 'absolute', left: 0, top: 0, bottom: 0, width: '20%',
                  background: 'transparent', border: 'none', cursor: 'pointer', zIndex: 2
                }}
              >
                <div style={{
                  position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)',
                  background: 'rgba(255, 255, 255, 0.1)', border: '1px solid #ffffff',
                  color: '#ffffff', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)'
                }}>
                  {'<'}
                </div>
              </button>
            )}

            {/* 当前图片 */}
            <img 
              src={actionPhotos[currentPhotoIndex].src} 
              alt="Action" 
              style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
            />

            {/* 右翻页按钮 */}
            {actionPhotos.length > 1 && (
              <button 
                onClick={nextPhoto}
                style={{
                  position: 'absolute', right: 0, top: 0, bottom: 0, width: '20%',
                  background: 'transparent', border: 'none', cursor: 'pointer', zIndex: 2
                }}
              >
                <div style={{
                  position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
                  background: 'rgba(255, 255, 255, 0.1)', border: '1px solid #ffffff',
                  color: '#ffffff', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)'
                }}>
                  {'>'}
                </div>
              </button>
            )}

            {/* 图片指示器 */}
            <div style={{
              position: 'absolute', bottom: '10px', left: '50%', transform: 'translateX(-50%)',
              background: 'rgba(0,0,0,0.6)', color: '#ffffff', padding: '2px 8px',
              fontFamily: "'Manolo Mono', monospace", fontSize: '12px', border: '1px solid rgba(255,255,255,0.2)'
            }}>
              {currentPhotoIndex + 1} / {actionPhotos.length}
            </div>
            
          </div>
        </div>
      )}

      {/* 💡 周边弹窗 */}
      <SwagModal
        open={swagOpen}
        lang={swagLang}
        setLang={setSwagLang}
        onClose={() => setSwagOpen(false)}
      />

    </div>
  )
}
export default Index